import React from 'react'

import { Box, Typography } from "@mui/material"
import { FlagsIconSeeker } from "@ui-seeker/core"
import { translateCountryName } from "@ui-seeker/utils"


export default function countriesColumn() {

	return [{
		name: "idCountriesName",
		label: "Countries",
		options: {
			display: 'excluded',
			customBodyRowRender: value => value?.map(({ name }) => name)[0] || "Without Country"
		}
	}
		, {
			name: 'idCountries',
			label: 'Countries',
			options: {
				filter: false,
				customBodyRowRenderLite: value => <Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyContent: "flex-start",
						flexDirection: "column",
						gap: .5
					}}>
					{value?.map((country, idx) => <Box
						key={`${idx}-${country}`}
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "flex-start",
							gap: .5
						}}>
						<FlagsIconSeeker countryName={country}/>
						<Typography>{translateCountryName(country)}</Typography>
					</Box>)}
				</Box>,
			}
		}]
}